__turbopack_context__.v({
  "loader": "Loader-module-scss-module__gsNpFG__loader",
});
